import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {
  checkIsCrmIntegrationConnected,
  extractCrmIntegrationUsername,
} from '../../../../../../../../../src/helpers/integrationHelpers';
import {makeMapStateToProps, ResolveStateProps} from '../../../../../../../../../src/helpers/reselectHelpers';
import {CrmSyncSourcesEnum} from '../../../../../../../../../src/models/api/crmSyncModel';
import {
  getIsCrmSyncLoading,
  makeGetAccountCrmSyncViaSource,
  makeGetCardCrmSyncViaSource,
} from '../../../../../../../../../src/store/data/crmSync/crmSyncSelectors';
import {getCrmIntegration} from '../../../../../../../../../src/store/data/integrations/integrationSelectors';
import {ContactsManagerPanelId} from '../../../../../../../../../src/store/panels/panelStateBase';
import {HandlerOf} from '../../../../../../../../shared/helpers/src/react/reactHelpers';
import {CrmSyncSettingsFormModel, CrmSyncsSettings} from './crmSyncsSettings';

/*
 * Props.
 */

interface CrmSyncsSettingsPublicProps {
  panelId: ContactsManagerPanelId;
  source: CrmSyncSourcesEnum;
  isSaving: boolean;
  onChange: HandlerOf<CrmSyncSettingsFormModel>;
}

type CrmSyncsSettingsContainerStateProps = ResolveStateProps<typeof mapStateToProps>;
export type CrmSyncsSettingsContainerProps = CrmSyncsSettingsPublicProps &
  CrmSyncsSettingsContainerStateProps;

/*
 * Selectors.
 */

const getIsConnected = createSelector([getCrmIntegration], checkIsCrmIntegrationConnected);

const getUsername = createSelector([getCrmIntegration], extractCrmIntegrationUsername);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CrmSyncsSettingsPublicProps>()(() => {
  const getCrmAccountSync = makeGetAccountCrmSyncViaSource();
  const getCrmCardSync = makeGetCardCrmSyncViaSource();

  return {
    accountCrmSync: getCrmAccountSync,
    cardCrmSync: getCrmCardSync,
    isConnected: getIsConnected,
    username: getUsername,
    isCrmSyncLoading: getIsCrmSyncLoading,
  };
});

export const CrmSyncsSettingsContainer = connect(mapStateToProps)(CrmSyncsSettings);
